<div fxFlex.xs="1 1" class="pagination-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px"
	fxLayoutGap.xs="15px">
	<div fxFlex.xs="1 1" fxLayout="row" class="pagination-content" fxLayoutAlign="space-between stretch" fxLayoutGap="5px"
		fxLayoutGap.xs="10px">
		<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 1 50%">
			<mat-icon class="prev" svgIcon="back" [ngClass]="{'disabled': actionBtns?.prevBtn}"
				(click)="playAction('previous')"></mat-icon>
			<p fxHide.xs class="prev-content cursor-pointer" *ngIf="[null, undefined, false].includes(actionBtns?.prevBtn)"
				(click)="playAction('previous')">
				{{(playlistData[selectedIndex - 1]) ? playlistData[selectedIndex - 1]?.title :
				playlistData[playlistData?.length - 1]?.title }}
			</p>
			<p fxHide fxShow.xs class="prev-content cursor-pointer"
				*ngIf="[null, undefined, false].includes(actionBtns?.prevBtn)" (click)="playAction('previous')">
				{{locale.translate('previous')}}</p>
		</div>
		<mat-divider [vertical]="'true'"></mat-divider>
		<div fxLayout="row" fxLayoutAlign="end center" fxFlex="1 1 50%">
			<p fxHide.xs class="next-content cursor-pointer" *ngIf="[null, undefined, false].includes(actionBtns?.nextBtn)"
				(click)="playAction('next')">
				{{(playlistData[selectedIndex + 1]) ? playlistData[selectedIndex + 1]?.title : playlistData[0]?.title}}</p>
			<p fxHide fxShow.xs class="next-content cursor-pointer"
				*ngIf="[null, undefined, false].includes(actionBtns?.nextBtn)" (click)="playAction('next')">
				{{locale.translate('next')}}</p>
			<mat-icon class="next" svgIcon="next" [ngClass]="{'disabled': actionBtns?.nextBtn}" (click)="playAction('next')">
			</mat-icon>
		</div>
	</div>
</div>
